export default __webpack_public_path__ + "fbd082f526fdf5c2e6db4e90503059ab.gif";